// extracted by mini-css-extract-plugin
export default {"squareCardsContainer":"CardsContainer_squareCardsContainer__ckIdy","cardsContainer":"CardsContainer_cardsContainer__B5C0y"};